import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import PersonIcon from '@mui/icons-material/Person';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import {
  Box,
  Button,
  Container,
  Switch,
  Tab,
  Tabs,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import ChromeDinoGame from 'react-chrome-dino';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { checkAccessLeader } from '../../helpers/utils/RoleManager';
import AdminPage from './Admin.jsx';
import AlertMessage from './AlertMessage.jsx';
import LastMessages from './LastMessages.jsx';
import { MEPInterface } from './MEPInterface.jsx';
import OnlineUsers from './OnlineUsers.jsx';

const Administration = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const users = useSelector((state) => state?.static?.users);
  const profile = useSelector((state) => state?.login?.profile);
  const [contentTab, setContentTab] = useState('Users');

  const [isDeleteAllowed, setIsDeleteAllowed] = useState(false);

  const handleRedirect = () => {
    navigate('/inbox');
  };

  const pagesSwitch = (content) => {
    switch (content) {
      case 'Users':
        return (
          <AdminPage
            isDeleteAllowed={isDeleteAllowed}
            elements={users}
            apiPath={'users'}
            cells={['Email', 'Prénom', 'Nom', 'Actif', 'Rôles']}
          />
        );
      case 'Alerts':
        return <AlertMessage />;
      case 'OnlineUsers':
        return <OnlineUsers />;
      case 'Messages':
        return <LastMessages />;
      case 'MEP':
        return <MEPInterface />;
      default:
        return null;
    }
  };

  const handleContentChange = (event, newValue) => {
    setContentTab(newValue);
  };

  const handleSwitchChange = (_event) => {
    setIsDeleteAllowed(!isDeleteAllowed);
  };

  return checkAccessLeader(profile) ? (
    <Container maxWidth="full">
      <Box
        sx={{
          display: 'flex',
          marginLeft: -4,
        }}
      >
        {profile.roles.some((role) => role.name === 'Super-Administrateur') ? (
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={contentTab}
            onChange={handleContentChange}
            sx={{
              width: 180,
              position: 'sticky', // Reste fixé en haut
              top: 64, // Positionnement en haut
              height: '100vh', // Remplit la hauteur de l'écran
              overflowY: 'auto', // Ajoute un scroll interne si nécessaire
              zIndex: 1000, // Reste au-dessus du contenu
              flexShrink: 0,
            }}
          >
            <Tab icon={<PersonIcon />} value={'Users'} label={'Utilisateurs'} />
            <Tab
              icon={<NotificationsActiveIcon />}
              value={'Alerts'}
              label={'Alertes'}
            />
            <Tab
              icon={<VerifiedUserIcon />}
              value={'OnlineUsers'}
              label={'Utilisateurs connectés'}
            />
            <Tab
              icon={<RocketLaunchIcon />}
              value={'MEP'}
              label={'Interface de déploiement'}
            />
            <Tab
              icon={<LocalPostOfficeIcon />}
              value={'Messages'}
              label={'Derniers messages'}
            />
          </Tabs>
        ) : (
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={contentTab}
            onChange={handleContentChange}
            sx={{ width: 180 }}
          >
            <Tab icon={<PersonIcon />} value={'Users'} label={'Utilisateurs'} />
          </Tabs>
        )}
        <Box
          sx={{
            flexGrow: 1, // Pour occuper l'espace restant
            padding: '0.1rem',
            // height: "100vh", // Hauteur max pour scroll interne
            overflowY: 'auto', // Active le scroll indépendant
          }}
        >
          {pagesSwitch(contentTab)}
        </Box>
        {!['Alerts', 'OnlineUsers', 'MEP'].includes(contentTab) && ( //FIXME: Condition be like : 'contentTab !== 'Users' ?
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: '15px',
              marginLeft: '20px',
              top: 80, // Positionnement en haut
              position: 'sticky', // Reste fixé en haut
              height: '100vh', // Remplit la hauteur de l'écran
              overflowY: 'auto', // Ajoute un scroll interne si nécessaire
            }}
          >
            <Typography>Suppression</Typography>
            <Switch
              onChange={handleSwitchChange}
              defaultChecked={isDeleteAllowed}
              sx={{ marginLeft: '15px' }}
            />
          </Box>
        )}
      </Box>
    </Container>
  ) : (
    <Box sx={{ marginTop: '35vh' }}>
      <ChromeDinoGame />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          color: theme.palette.info.main,
        }}
      >
        <Button onClick={handleRedirect} size="small">
          Veuillez cliquez ici pour retourner dans votre Inbox
        </Button>
      </Box>
    </Box>
  );
};

export default Administration;
